import type { IconNode } from '../types';

/**
 * @name zap-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNzY4IDUuMTExIDEzLjQ0IDIuNDRhMS41IDEuNSAwIDAxMi40NzQgMS41NjFsLTEuNjMzIDQuNjI1IiAvPgogIDxwYXRoIGQ9Im0xOC44ODkgMTMuMjMyLjY3Mi0uNjcyQTEuNSAxLjUgMCAwMDE4LjUgMTBoLTIuODQ0IiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0ibTcuOTQgNy45NC0zLjUgMy40OTlBMS41IDEuNSAwIDAwNS41IDE0aDQuMDAyYS41LjUgMCAwMS40NzEuNjY2TDguMDg2IDIwYTEuNSAxLjUgMCAwMDIuNDc1IDEuNTZsNS41LTUuNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/zap-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ZapOff: IconNode = [
  ['path', { d: 'M10.768 5.111 13.44 2.44a1.5 1.5 0 012.474 1.561l-1.633 4.625' }],
  ['path', { d: 'm18.889 13.232.672-.672A1.5 1.5 0 0018.5 10h-2.844' }],
  ['path', { d: 'm2 2 20 20' }],
  [
    'path',
    {
      d: 'm7.94 7.94-3.5 3.499A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l5.5-5.5',
    },
  ],
];

export default ZapOff;
